<template>
    <div class="animated fadeIn">              
        <b-card>
            <div slot="header">
                <i class="cui-calendar"></i> Links de Pagamento
                <b-link :to="actionUri" class="btn mr-2 btn-sm btn-primary float-right">
                <i class="fa fa-angle-left"></i>
                Voltar
                </b-link>
            </div>
            <form @submit.prevent="validate" class="needs-validation" novalidate>
                <div class="form-row justify-content-start" v-show="isPartner && !isEdit">
                    <div class="col-md-3">
                        <label>Selecione a empresa:</label>
                        <model-list-select :list="partnerRequest.data"
                            option-value="id"
                            option-text="name"
                            v-model="partnerRequest.selected"
                            :placeholder="`Digite o nome da empresa`"
                            @searchchange="searchData">
                        </model-list-select>
                    </div>
                </div>
                <div class="form-row justify-content-start"  v-show="isPartner && isEdit">
                    <div class="col-sm-12 col-md-5">
                        <div class="form-group">
                            <label>Empresa</label>
                            <div class="form-control-plaintext"><strong>{{model.sellerName}}</strong></div>                                
                        </div>
                    </div>
                </div>
                <div class="form-row justify-content-start">
                    <div class="col-sm-12 col-md-4">
                        <base-input :disabled="isEdit" type="text" label="Nome" required placeholder="" v-model="model.name" v-validate="modelValidations.name" data-vv-name="name" data-vv-as="nome" maxlength="255" :error="getError('name')" />                        
                    </div>                    
                </div>
                <div class="form-row justify-content-start">
                    <div class="col-sm-12 col-md-2">
                        <div class="form-group">
                            <label>Valor</label>
                            <vue-numeric
                                :separator="vueNumericDefaults.separator"
                                :precision="vueNumericDefaults.decimals"
                                :output-type="vueNumericDefaults.outputType"
                                :disabled="isEdit"
                                v-model="model.amount"
                                v-validate="modelValidations.amount"
                                data-vv-name="amount"
                                data-vv-as="Valor"
                                :class="{'form-control': true, 'is-invalid': errors.has('amount') ? true : false}"
                            />                                
                            <div
                                v-show="errors.has('amount')"
                                class="invalid-feedback"
                            >{{ errors.first('amount') }}</div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-1">
                        <div class="form-group">
                            <label>Parcela</label>
                            <select :disabled="isEdit" :class="{'custom-select': true}" v-model="model.installmentCount">
                                <option v-for="(opt, idx) in installmentList" :key="idx" :value="opt.value" :disabled="opt.disabled" >
                                    {{opt.text}}
                                </option>
                            </select>                                        
                        </div>
                    </div>
                </div>
                <div class="form-row justify-content-start" v-show="isEdit">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Status</label>
                            <div class="form-control-plaintext"><strong>{{statusName}}</strong></div>                                
                        </div>
                    </div>
                </div>
                <div class="form-row justify-content-start" v-show="action == 'edit_paymentlink'">
                    <div class="col-sm-3">
                        <div class="form-group">
                            <label>Criado em</label>
                            <input disabled type="text" v-model="createdAt" class="form-control-plaintext" />                                
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-group">
                            <label>Atualizado em</label>
                            <input disabled type="text" v-model="updatedAt" class="form-control-plaintext" />                                
                        </div>
                    </div>
                </div>
                <button v-show="!isEdit" type="submit" class="btn btn-primary">Salvar</button>
            </form>
        </b-card>         
    </div>
</template>
<script>
import domainService from '../../../services/PaymentLinks/paymentLinkService'
import sellerService from '../../../services/Customer/sellerService'
import editPage from '../../../mixins/editPage'
import moment from 'moment';
import { ModelListSelect } from 'vue-search-select'
export default {
    props: {
        id: String
    },
    components: {      
        ModelListSelect
    },
    mixins: [editPage],
    data() {
        return {
            actionUri: '/partners/paymentLinks',
            vueNumericDefaults:{
                decimals: 2,
                separator: '.',
                outputType: 'Number'
            },         
            partnerRequest: {
                selected: '',
                data: []
            },
            model: {
                name: '',
                id: '',
                sellerId: '',
                status: 'CREATED',
                installmentCount: null
            },
            installmentList: this.getInstallmentsList(),       
            modelValidations: {
                name: {
                    required: true,
                    max: 255
                },
                amount: {required: true}
            }
        }
    },
    computed: {
        action() {
            return this.$route.name
        },
        isPartner() {
            return this.$auth.isPartner;
        },
        isEdit() {
            return this.action == 'edit_paymentlink'
        },
        createdAt() {
            return this.formatDateTimeFields(this.model.createdAt)
        },
        updatedAt() {
            return this.formatDateTimeFields(this.model.updatedAt)
        },
        statusName() {
            switch(this.model.status)
            {
                case 'CREATED':
                    return 'Criado';
                case 'PROCESSING':
                    return 'Processando';
                case 'CANCELED':
                    return 'Cancelado';
                case 'EXPIRED':
                    return 'Expirado';
                case 'PAID':
                    return 'Pago';
            }
        }
    },
    created(){
        this.fetchData()
    },
    methods: {
        searchData(newQuery) {
            if(newQuery.length < 2)
                return
            const self = this
            //this.showLoading()
            sellerService.all(newQuery).then((response) =>{
                self.partnerRequest.data = response.status == 204 ? [] : response.data
                //self.hideLoading()
            }, () =>{
                //self.hideLoading()
            })
        },
        fetchData() {
            let id = ''
            if(this.isEdit) {
                const self = this
                self.showLoading()
                domainService.find(this.id).then((response) =>{
                    self.model = response.data
                    self.hideLoading()
                }, () => {
                    self.hideLoading()
                })
            }
        },
        formatDateTimeFields(value) {
            return value == null || value == '' ? '' : moment(value).format('DD/MM/YYYY - HH:mm:ss');
        },
        getInstallmentsList() {
            let installments = [];
            installments.push({
                value: null,
                text: `Selecione`,
                disabled: false
            });
            for(let i = 1; i <= 18; i++)
            {
                installments.push({
                    value: i,
                    text: `${i}x`,
                    disabled: false
                });
            }
            return installments;
        },        
        validate() {
            if(this.isEdit) {
                return
            }
            const self = this
            self.showLoading()
            this.$validator.validateAll().then(isValid => {
                if (isValid) {                                        
                    let request = {
                        id: '',
                        name: self.model.name,
                        status: 'CREATED',
                        amount: self.model.amount,
                        installmentCount: self.model.installmentCount,
                        sellerId: self.isPartner ? self.partnerRequest.selected : ''
                    }
                    domainService.create(request).then(() => {
                        self.hideLoading()
                        self.$router.push({ path:self.actionUri})
                    })                    
                } 
                else 
                {
                    self.hideLoading()
                }
            })
        }
    }
}
</script>
